import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleLotOverviewPageTourConfig: AgTechTourConfig = {
    id: 'sale-lot-overview-page-tour',
    name: 'Sell Lots Tour',
    steps: [
        {
            targetId: 'sale-lots-selling-grid',
            title: 'Lot Selling Grid',
            description: 'Your primary tool for recording lot sales. Select a lot row, assign a winning bidder, and enter the purchase price to mark it sold.',
            position: 'right',
        },
        {
            targetId: 'sale-lots-in-sale-metric',
            title: 'Lots In Sale',
            description: 'Total number of lots entered in this sale.',
            position: 'left',
        },
        {
            targetId: 'sale-lots-sold-metric',
            title: 'Lots Sold',
            description: 'Lots with a winning bidder and purchase price recorded.',
            position: 'left',
        },
        {
            targetId: 'sale-lots-invoiced-metric',
            title: 'Lots Invoiced',
            description: 'Sold lots that have already been included in a buyer\'s invoice. Once invoiced, a lot moves out of the invoicing queue.',
            position: 'left',
        },
        {
            targetId: 'sale-lots-manage-btn',
            title: 'Manage Lots',
            description: 'Open the lot management panel to view all lots, make bulk edits, or access the selling and update grids in a larger view.',
            position: 'left',
        },
    ]
}
